/**
 * Handle xhr response errors
 * @author      Jeff Adams <jeff@tinyfly.com>
 * @copyright   Traxo, Inc. 2019
 */

import { store } from '@/state/store.js';

/**
 * Error Handler from API responses
 * @param {Object} error - the thrown error response
 * @param {Function} next - vue-router's next route function
 * @param {String} [resource] - The item that was being requested which errored
 */
export function handleErrors(error = {}, next, resource) {
  // The user needs to log in
  if (error.response && error.response.status === 401) {
    // @TODO: For now just reload the page so Laravel can handle session timeout.
    // In the future we may completely control everything on the front-end
    return window.location.reload();
  }

  // Otherwise set a resource notification
  store.dispatch('notifications/create', {
    type: 'resource',
    status: error.response ? error.response.status : null,
    resource: resource,
  });

  if (typeof next === 'function') {
    next();
  }
}
